export default __webpack_public_path__ + "static/media/upload-sample.a1684e3d.webp";